import { Link } from "react-router-dom";
import { faqs } from "@/mocks/site";
import Accordion from "@/components/base/Accordion";
import SectionHeading from "@/components/base/SectionHeading";

export default function HomeFaq() {
  return (
    <section className="w-full bg-background-100 py-10 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-[1fr_1.6fr]">
          <div>
            <SectionHeading
              eyebrow="帮助中心"
              title="你可能想问"
              desc="关于分类方式、数据来源与信息真实性的常见问题。"
            />
            <Link
              to="/faq"
              className="mt-2 inline-flex w-fit cursor-pointer items-center gap-2 rounded-full bg-primary-500 px-5 py-2.5 text-sm font-semibold whitespace-nowrap text-background-50 transition-colors hover:bg-primary-600"
            >
              查看全部问题
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
          <Accordion items={faqs.slice(0, 4)} />
        </div>
      </div>
    </section>
  );
}